"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_redux_1 = require("react-redux");
const constants_1 = require("../../../slice/sliceReview/constants");
const selectors_1 = __importDefault(require("../../../slice/selectors"));
const sliceReview_1 = require("../../../slice/sliceReview");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../../../reviews/helper");
const URL_THUMB = `${helper_1.URLS.pulse}openpreview.php?format=thumb&assetid=`;
const DEFAULT_OPTIONS = [
    {
        type: constants_1.OPTION.existing,
        label: 'Select Existing File',
    },
    {
        type: constants_1.OPTION.upload,
        label: 'Upload New File',
    },
    { type: constants_1.OPTION.url, label: 'Enter website/URL' },
];
const PREVIOUS_ASSET_REVIEW_OPTIONS = [
    ...DEFAULT_OPTIONS,
    {
        type: constants_1.OPTION.previous,
        label: `Select Asset From Previous Round`,
    },
];
const PREVIOUS_URL_REVIEW_OPTIONS = [
    ...DEFAULT_OPTIONS,
    {
        type: constants_1.OPTION.previous,
        label: `Select Website (URL) From Previous Round`,
    },
];
const OptionCreateReview = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { currentStage, project, round, historyPhases, phase, url, } = (0, react_redux_1.useSelector)(selectors_1.default);
    const isUrlReviewType = (0, helper_1.isUrlSourceType)(round, currentStage, url);
    const hasPreviousReview = !!(round === null || round === void 0 ? void 0 : round.id);
    const options = (0, react_1.useMemo)(() => {
        if (round === null || round === void 0 ? void 0 : round.id) {
            if (isUrlReviewType) {
                return PREVIOUS_URL_REVIEW_OPTIONS;
            }
            return PREVIOUS_ASSET_REVIEW_OPTIONS;
        }
        return DEFAULT_OPTIONS;
    }, [isUrlReviewType, hasPreviousReview]);
    const handleClick = (option) => {
        dispatch((0, sliceReview_1.selectOption)(option));
        dispatch((0, sliceReview_1.nextModal)());
    };
    (0, react_1.useEffect)(() => {
        if (currentStage) {
            dispatch((0, sliceReview_1.enableNextBtn)());
        }
    }, [currentStage, historyPhases]);
    const previousSrc = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        let src = '';
        if (Array.isArray(round === null || round === void 0 ? void 0 : round.source) && ((_a = round === null || round === void 0 ? void 0 : round.source[0]) === null || _a === void 0 ? void 0 : _a.asset)) {
            src = `${URL_THUMB}${(_c = (_b = round === null || round === void 0 ? void 0 : round.source[0]) === null || _b === void 0 ? void 0 : _b.asset) === null || _c === void 0 ? void 0 : _c.id}`;
        }
        if ((0, helper_1.isUrlSourceType)(round, currentStage, url) &&
            ((round === null || round === void 0 ? void 0 : round.round_thumbnail_link) || (round === null || round === void 0 ? void 0 : round.thumbnailLink))) {
            src = (round === null || round === void 0 ? void 0 : round.round_thumbnail_link) || (round === null || round === void 0 ? void 0 : round.thumbnailLink);
        }
        return src;
    }, [round === null || round === void 0 ? void 0 : round.thumbnailLink, round === null || round === void 0 ? void 0 : round.source, phase]);
    const PreviousOption = () => {
        return previousSrc !== '' ? (react_1.default.createElement("img", { className: styles_modules_less_1.default['option-item__img'], src: previousSrc })) : (react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-browser', styles_modules_less_1.default['option-item__icon']) }));
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['modal-option__root'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['modal-option__title'] },
            react_1.default.createElement("h4", { className: styles_modules_less_1.default['title-option__label'] }, "Select type of review you would like to create"),
            react_1.default.createElement("span", { className: styles_modules_less_1.default['title-option__jobTitle'] },
                "Project:",
                react_1.default.createElement("span", { className: styles_modules_less_1.default['job-title__content'] }, (project === null || project === void 0 ? void 0 : project.label)
                    ? `${project === null || project === void 0 ? void 0 : project.label}`
                    : (round === null || round === void 0 ? void 0 : round.job_title) || (round === null || round === void 0 ? void 0 : round.jobTitle)))),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['modal-option__list'] }, options.map((option) => {
            return (react_1.default.createElement("div", { key: option.type, className: (0, clsx_1.default)(styles_modules_less_1.default['modal-option__item'], currentStage === option.type &&
                    styles_modules_less_1.default['modal-option__item--selected']), onClick: () => handleClick(option.type) },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['option-item__content'] },
                    option.type === constants_1.OPTION.previous ? (react_1.default.createElement(PreviousOption, null)) : (react_1.default.createElement("i", { className: (0, clsx_1.default)(option.type === constants_1.OPTION.existing &&
                            'fal fa-image-polaroid', option.type === constants_1.OPTION.upload && 'fal fa-cloud-upload', option.type === constants_1.OPTION.url && 'fal fa-globe', styles_modules_less_1.default['option-item__icon']) })),
                    react_1.default.createElement("h4", { className: styles_modules_less_1.default['option-item__label'] }, option.label))));
        }))));
};
exports.default = OptionCreateReview;
